import { getFaqsApi } from "../sevices/faqService";

export const getFaqs = (token) => async (dispatch) => {
  await dispatch(getFaqsApi(token));
};
